var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 8.06253V5.97919C13.75 3.90813 12.0711 2.22919 10 2.22919C7.92893 2.22919 6.25 3.90813 6.25 5.97919V8.06253",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 8.06253H5.00017C4.07963 8.06253 3.33341 8.80881 3.3335 9.72936L3.3342 17.2294C3.33428 18.1498 4.08045 18.8959 5.00086 18.8959H15C15.9205 18.8959 16.6667 18.1497 16.6667 17.2292V9.7292C16.6667 8.80872 15.9205 8.06253 15 8.06253Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0759 13.4792H12.0834M7.91669 13.4792H7.92416",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLockIcon);
export default __webpack_public_path__ + "static/media/password-lock-icon.a616b30d1919ee47a92d1594122b1678.svg";
export { ForwardRef as ReactComponent };